import { getSessionUUID } from '../components/lib/AuthToken';
import logger from "../utils/logger";

// Generate a new purchase order
export const generate_purchase_order = async (poData) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(poData)
        };

        const response = await fetch('/purchase_orders/generate_po', requestOptions);
        const data = await response.json();
        
        return { data, status: response.status };
    } catch (error) {
        logger.error('Error generating purchase order:', error);
        return { data: { error: 'Network error' }, status: 500 };
    }
};

// Get today's purchase orders
export const get_todays_purchase_orders = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };

        const response = await fetch('/purchase_orders/todays_pos', requestOptions);
        const data = await response.json();
        
        return { data, status: response.status };
    } catch (error) {
        logger.error('Error fetching today\'s purchase orders:', error);
        return { data: { error: 'Network error' }, status: 500 };
    }
};

// Search purchase orders by PO number
export const search_purchase_orders_by_po = async (poNumber) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ po_number: poNumber })
        };

        const response = await fetch('/purchase_orders/search_by_po', requestOptions);
        const data = await response.json();
        logger.log("search by po: ", data);
        return { data, status: response.status };
        
    } catch (error) {
        logger.error('Error searching purchase orders by PO:', error);
        return { data: { error: 'Network error' }, status: 500 };
    }
};

// Search purchase orders by date range
export const search_purchase_orders_by_date_range = async (dateRange) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(dateRange)
        };

        const response = await fetch('/purchase_orders/search_by_date_range', requestOptions);
        const data = await response.json();
        logger.log("search by date: ", data);
        return { data, status: response.status };
    } catch (error) {
        logger.error('Error searching purchase orders by date range:', error);
        return { data: { error: 'Network error' }, status: 500 };
    }
};

// Update purchase order (PO number and comment)
export const update_purchase_order = async (poData) => {
    try {
        const sessionToken = await getSessionUUID();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(poData)
        };
        const response = await fetch('/purchase_orders/update_po_number', requestOptions);
        const data = await response.json();
        return { data, status: response.status };
    } catch (error) {
        logger.error('Error updating purchase order:', error);
        return { data: { error: 'Network error' }, status: 500 };
    }
};

// Get all purchase order categories
export const get_po_categories = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };
        const response = await fetch('/purchase_orders/categories', requestOptions);
        const data = await response.json();
        return { data, status: response.status };
    } catch (error) {
        logger.error('Error fetching PO categories:', error);
        return { data: { error: 'Network error' }, status: 500 };
    }
};